export default __webpack_public_path__ + "static/media/climate.ff87720a.jpg";